<template lang="html">
	<div class="fbga" v-show="fpgaShow">
		<!-- banner图 -->
		<div class="banner"></div>

		<div class="content">
			<!-- 课程设计完全对应大厂岗位要求 -->
			<div class="zeroModule">
				<img src="../../assets/image/fbga/title_0.png" alt="" style="height:6rem">
				<p class="zeroModuleDescribe">立足技能掌握与实战 培养符合大厂需求的人才</p>
				<ul class="zeroModuleList">
					<li>
						<div class="listChild">
							<div class="childNum">
								<p>1</p>
							</div>
							<p class="childText">带你精通Verilog及VHDL逻辑电路设计编程语言</p>
						</div>
						<div class="fillChild">
							<p></p>
						</div>
					</li>
					<li>
						<div class="listChild">
							<div class="childNum">
								<p>2</p>
							</div>
							<p class="childText">掌握数字设计方法，包括时序优化、时序约束、设计实现等</p>
						</div>
						<div class="fillChild">
							<p></p>
						</div>
					</li>
					<li>
						<div class="listChild">
							<div class="childNum">
								<p>3</p>
							</div>
							<p class="childText">掌握仿真验证方法及基本测试程序编写</p>
						</div>
						<div class="fillChild">
							<p></p>
						</div>
					</li>
					<li>
						<div class="listChild">
							<div class="childNum">
								<p>4</p>
							</div>
							<p class="childText">掌握DDR3、DDR4、PCL-e、USB等接口电路的设计</p>
						</div>
						<div class="fillChild">
							<p></p>
						</div>
					</li>
					<li>
						<div class="listChild">
							<div class="childNum">
								<p>5</p>
							</div>
							<p class="childText">基于全球领先的Xilinx开发工具vivido在开发板的演练，全面掌握FPGA研发流程</p>
						</div>
					</li>
				</ul>
				<p class="employment">某大厂FPGA工程师岗位招聘 ↓↓↓</p>
				<div class="swiper-container swiper1">
					<div class="swiper-wrapper">
						<div class="swiper-slide swiperOneCon">
							<img src="../../assets/image/fbga/textNo1.jpg" alt="" class="jobRequirements">
						</div>
						<div class="swiper-slide swiperOneCon">
							<img src="../../assets/image/fbga/textNo3.jpg" alt="" class="jobRequirements">
						</div>
						<div class="swiper-slide swiperOneCon">
							<img src="../../assets/image/fbga/textNo2.jpg" alt="" class="jobRequirements">
						</div>
					</div>
					<div class="swiper-pagination swiper_dian"></div>
				</div>
			</div>

			<!-- 为什么要学这门课 -->
			<div class="first_model">
				<img src="../../assets/image/fbga/title_1.png" alt="" style="height:6rem">
				<div class="tab_bar" :class="{tabBtn: xHeader}">
					<ul class="tab_con">
						<li class="first_tab" id="tab1" @click="tabNum = 0" :class="{decorationLine:tabNum == 0}">
							<img class="tab_icon" src="../../assets/image/fbga/iconNo1.png" alt="" :class="{image1:tabNum != 0}">
							<img class="tab_icon" src="../../assets/image/fbga/icon_no1.png" alt="" :class="{image2:tabNum == 0}">
							<img class="down_icon" src="../../assets/image/fbga/down.png" alt="" v-show="tabNum == 0">
						</li>
						<li class="wire">
							<img src="../../assets/image/fbga/wire.png" alt="">
						</li>
						<li class="first_tab" id="tab2" @click="tabNum = 1" :class="{decorationLine:tabNum == 1}">
							<img class="tab_icon" src="../../assets/image/fbga/iconNo2.png" alt="" :class="{image1:tabNum != 1}">
							<img class="tab_icon" src="../../assets/image/fbga/icon_no2.png" alt="" :class="{image2:tabNum == 1}">
							<img class="down_icon" src="../../assets/image/fbga/down.png" alt="" v-show="tabNum == 1">
						</li>
						<li class="wire">
							<img src="../../assets/image/fbga/wire.png" alt="">
						</li>
						<li class="first_tab" id="tab3" @click="tabNum = 2" :class="{decorationLine:tabNum == 2}">
							<img class="tab_icon" src="../../assets/image/fbga/iconNo3.png" alt="" :class="{image1:tabNum != 2}">
							<img class="tab_icon" src="../../assets/image/fbga/icon_no3.png" alt="" :class="{image2:tabNum == 2}">
							<img class="down_icon" src="../../assets/image/fbga/down.png" alt="" v-show="tabNum == 2">
						</li>
						<li class="wire">
							<img src="../../assets/image/fbga/wire.png" alt="">
						</li>
						<li class="first_tab" id="tab4" @click="tabNum = 3" :class="{decorationLine:tabNum == 3}">
							<img class="tab_icon" src="../../assets/image/fbga/iconNo4.png" alt="" :class="{image1:tabNum != 3}">
							<img class="tab_icon" src="../../assets/image/fbga/icon_no4.png" alt="" :class="{image2:tabNum == 3}">
							<img class="down_icon" src="../../assets/image/fbga/down.png" alt="" v-show="tabNum == 3">
						</li>
					</ul>
				</div>
				<div class="">
					<div class="tab_css" id="tab1_content" v-show="tabNum == 0">
						<div class="first_model_con">
							<div class="first_img">
								<img src="../../assets/image/fbga/image_1.png" alt="">
							</div>
							<div class="first_text">
								<p class="first_text_title">FPGA应用前景广泛</p>
								<p class="first_text_con">
									FPGA作为万能积木应用,被广泛运用到通讯（5G）,
									图像处理，数据处理、网络、仪器、工业控制以及人工智能计算加速等各个领域
								</p>
							</div>
						</div>
					</div>
					<div class="tab_css" id="tab2_content" v-show="tabNum == 1">
						<div class="first_model_con">
							<div class="first_img">
								<img src="../../assets/image/fbga/image_2.png" alt="">
							</div>
							<div class="first_text">
								<p class="first_text_title">人才需求旺盛</p>
								<p class="first_text_con">
									目前FPGA和IC设计行业至少有20-30万的人才缺口；
									70%被访企业认为中级水平以上工程师严重不足,
									FPGA工程师已成为电子企业研发及IC设计迫切需要的人才
								</p>
							</div>
						</div>
					</div>
					<div class="tab_css" id="tab3_content" v-show="tabNum == 2">
						<div class="first_model_con">
							<div class="first_img">
								<img src="../../assets/image/fbga/image_3.jpg" alt="">
							</div>
							<div class="first_text">
								<p class="first_text_title">平均薪酬行业最高</p>
								<p class="first_text_con">
									大厂高薪诚聘FPGA工程师，仍面临“招人难”、“无人问津”的尴尬境地
								</p>
							</div>
						</div>
					</div>
					<div class="tab_css" id="tab4_content" v-show="tabNum == 3">
						<div class="first_model_con">
							<div class="first_img">
								<img src="../../assets/image/fbga/image_4.png" alt="">
							</div>
							<div class="first_text">
								<p class="first_text_title">自学效率低、面试通不过</p>
								<p class="first_text_con">
									无法接触一线项目实战，缺乏经验，时间消耗大，无人辅导容易走弯路，
									面试时才发现无法满足企业用人需求
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="second_model">
				<img src="../../assets/image/fbga/title_2.png" alt="" style="height:6rem">
				<ul class="second_model_list">
					<li class="second_model_con">
						<img src="../../assets/image/fbga/second_1.png" alt="">
						<div class="second_text">
							<p class="second_text_title">电子工程师</p>
							<p class="second_text_con">基层搬砖，想快速提升自己的薪酬水平</p>
						</div>
					</li>
					<li class="second_model_con">
						<img src="../../assets/image/fbga/second_2.png" alt="">
						<div class="second_text">
							<p class="second_text_title">FPGA工程师企业岗前培训</p>
							<p class="second_text_con">帮助工程师增加实战经验，迅速上手项目</p>
						</div>
					</li>
					<li class="second_model_con">
						<img src="../../assets/image/fbga/second_3.png" alt="">
						<div class="second_text">
							<p class="second_text_title">电子信息类相关专业人员</p>
							<p class="second_text_con">本行业发展慢，急需转换赛道</p>
						</div>
					</li>
					<li class="second_model_con">
						<img src="../../assets/image/fbga/second_4.png" alt="">
						<div class="second_text_child">
							<p class="second_text_title">大学毕业生、在读研究生</p>
							<p class="second_text_con">实现从理论到实践的跨越，高薪就业</p>
						</div>
					</li>
				</ul>
			</div>
			<div class="third_model">
				<img src="../../assets/image/fbga/title_3.png" alt="" style="height:6rem">
				<ul class="third_model_list">
					<li class="third_model_con">
						<div class="third_text_num">
							<p>01</p>
							<img src="../../assets/image/fbga/else_cion.png" alt="">
						</div>
						<p class="third_text_con">50+全盘案例解析和项目实战，Xilinx企业应用级开发板实战演练，项目经验迅速积累</p>
					</li>
					<li class="third_model_con">
						<div class="third_text_num">
							<p>02</p>
							<img src="../../assets/image/fbga/else_cion.png" alt="">
						</div>
						<p class="third_text_con">从设计方法，时序，验证到接口，全面掌握FPGA核心技能</p>
					</li>
					<li class="third_model_con">
						<div class="third_text_num">
							<p>03</p>
							<img src="../../assets/image/fbga/else_cion.png" alt="">
						</div>
						<p class="third_text_con">能独立胜任FPGA系统硬件设计、逻辑设计、FPGA和IC验证工作</p>
					</li>
					<li class="third_model_con">
						<div class="third_text_num">
							<p>04</p>
							<img src="../../assets/image/fbga/else_cion.png" alt="">
						</div>
						<p class="third_text_con">大厂高薪岗位内部推荐机会</p>
					</li>
					<li class="third_model_con">
						<div class="third_text_num">
							<p>05</p>
							<img src="../../assets/image/fbga/else_cion.png" alt="">
						</div>
						<p class="third_text_con">获得FPGA工程师结业证书，证明具备相对应的专业技能</p>
					</li>
				</ul>
			</div>
			<div class="fourth_model">
				<img src="../../assets/image/fbga/title_4.png" alt="" style="height:6rem">
				<div class="fourth_model_con" :class="{tabBtn: xHeader}">
					<div class="fourth_model_list" @click="fourthClick(1, 'first')" v-bind:class="{'fourthTab': oneShow}">
						行业专家全流程项目解析与实战演练
					</div>
					<div class="fourth_model_list" @click="fourthClick(2, 'second')" v-bind:class="{'fourthTab': twoShow}">
						体系化课程内容<br>全覆盖
					</div>
					<div class="fourth_model_list" @click="fourthClick(3, 'third')" v-bind:class="{'fourthTab': threeShow}">
						职业规划与大厂<br>内推
					</div>
					<div class="fourth_model_list" @click="fourthClick(4, 'fourth')" v-bind:class="{'fourthTab': fourShow}">
						"教-学-练-测"全<br>场景教学平台
					</div>
					<img src="../../assets/image/fbga/circle.png" alt="" class="fourth_model_circle_img">
					<img src="../../assets/image/fbga/icon.png" alt="" class="fourth_model_list_img">
				</div>
				<div class="fourth_model_text">
					<div class="fourth_css" id="fourth1_content" style="display: block">
						基于行业专家亲自主导项目作为案例，手术刀式逐一解剖知识点，
						掌握FPGA器件原理和结构，FPGA开发流程，设计方法，仿真验证等
					</div>
					<div class="fourth_css" id="fourth2_content">
						从FPGA基础、Verilog HDL 基础、开发工具环境、设计方法与技巧、接口设计到开发板实战演练，
						全面覆盖一位FPGA高级工程师所需掌握的技能与方法
					</div>
					<div class="fourth_css" id="fourth3_content">
						提供职业发展规划指导，打通从"学会"到"就业"路径，与企业岗位接轨，
						帮你完成从FPGA学员到“高薪”工程师的角色转换
					</div>
					<div class="fourth_css" id="fourth4_content">
						全场景教学平台“巢粉引擎”，将学员的知识学习、实战和测验管理起来，
						每个学员都有学习档案，详细记录学习进度和测试结果
					</div>
				</div>
			</div>
			<div class="fifth_model">
				<img src="../../assets/image/fbga/title_5.png" alt="" style="height:6rem">
				<div class="">
					<div class="Tab_css" id="Tab1_content" style="display: block">
						<div class="teacher_con">
							<img class="teacher_head" src="../../assets/image/fbga/teacherNo1.png" alt="">
							<div class="teacher_txt">
								<p class="teacher_name">
									荣庆安老师
								</p>
								<p class="teacher_synopsis">
									原华为器件工程首席专家，器件归一化、器件失效分析实验室奠基人。
									从事器件工程相关工作20年多年，作为领域技术专家完成过交换机、路由器、传输、基站等多类产品器件工程设计工作，
									主持多项重大失效问题攻关，产品开发实战案例丰富。
								</p>
							</div>
						</div>
						<img class="down_1" src="../../assets/image/fbga/down.png" alt="">
					</div>
					<div class="Tab_css" id="Tab2_content">
						<div class="teacher_con">
							<img class="teacher_head" src="../../assets/image/fbga/teacherNo2.png" alt="">
							<div class="teacher_txt">
								<p class="teacher_name">
									高亚军老师
								</p>
								<p class="teacher_synopsis">
									现任Xilinx资深战略应用工程师，拥有电路与系统专业硕士学位。
									多年来使用Xilinx FPGA实现数字处理算法，
									对Xilinx FPGA器件架构、开发工具Vivado、Vitis HLS和System Generator以及设计理念有深厚的理论和实战经验。
								</p>
							</div>
						</div>
						<img class="down_2" src="../../assets/image/fbga/down.png" alt="">
					</div>
					<div class="Tab_css" id="Tab3_content">
						<div class="teacher_con">
							<img class="teacher_head" src="../../assets/image/fbga/teacherNo3.png" alt="">
							<div class="teacher_txt">
								<p class="teacher_name">
									景晶老师
								</p>
								<p class="teacher_synopsis">
									曾在九洲电器、华为等企业从事数字单板硬件设计研发工作近二十年，
									先后参与接口、处理、主控、基带、装备工具板等多种单板的硬件设计工作，
									有丰富的数字电路设计经验。
								</p>
							</div>
						</div>
						<img class="down_3" src="../../assets/image/fbga/down.png" alt="">
					</div>
					<div class="Tab_css" id="Tab4_content">
						<div class="teacher_con">
							<img class="teacher_head" src="../../assets/image/fbga/teacherNo4.png" alt="">
							<div class="teacher_txt">
								<p class="teacher_name">
									阮永生老师
								</p>
								<p class="teacher_synopsis">
									电巢FPGA高级讲师，电信科学技术研究院电子与通信系统硕士，
									从事FPGA研发工作十余年，主要方向为数字逻辑电路应用FPGA实现，
									进行VIVADO IP核级设计、前后仿真，到板卡硬件具体调测及实现。
									曾参与电信科学技术第四研究所、清华大学、北京邮电大学国家级重点实验室通信及图像产品的研发及系统设计等众多项目。
								</p>
							</div>
						</div>
						<img class="down_4" src="../../assets/image/fbga/down.png" alt="">
					</div>
					<div class="Tab_bar" :class="{TabBtn: xHeader}">
						<ul>
							<li id="tab1" @click="Myclick(1, 'all')" v-bind:class="{'DecorationLine':showAll}">
								<img class="teacher_icon" v-bind:class="{'opacity':showAll}" src="../../assets/image/fbga/teacherIcon1.jpg" alt="">
								<p class="teacherName" v-bind:class="{'color': showAll}">荣庆安老师</p>
							</li>
							<li id="tab2" @click="Myclick(2, 'await')" v-bind:class="{'DecorationLine':showAwait}">
								<img class="teacher_icon" v-bind:class="{'opacity':showAwait}" src="../../assets/image/fbga/teacherIcon2.jpg" alt="">
								<p class="teacherName" v-bind:class="{'color': showAwait}">高亚军老师</p>
							</li>
							<li id="tab3" @click="Myclick(3, 'accomplish')" v-bind:class="{'DecorationLine':showAccomplish}">
								<img class="teacher_icon" v-bind:class="{'opacity':showAccomplish}" src="../../assets/image/fbga/teacherIcon3.jpg" alt="">
								<p class="teacherName" v-bind:class="{'color': showAccomplish}">景晶老师</p>
							</li>
							<li id="tab4" @click="Myclick(4, 'cancel')" v-bind:class="{'DecorationLine':showCancel}">
								<img class="teacher_icon" v-bind:class="{'opacity':showCancel}" src="../../assets/image/fbga/teacherIcon4.jpg" alt="">
								<p class="teacherName" v-bind:class="{'color': showCancel}">阮永生老师</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="sixth_model">
				<img class="headline" src="../../assets/image/fbga/title_6.png" alt="" style="height:6rem">
				<p class="sixth_con_text">专家视频课+直播辅导答疑+作业点评</p>
				<p class="sixth_con_text">多平台专家全程带学 无死角追踪学习效果</p>
				<div class="sixth_portion">
					<div class="sixth_model_con">
						<div class="sixth_con_title">
							<p>FPGA基础</p>
							<span>（10课时）</span>
						</div>
						<ul class="sixth_model_list">
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">FPGA简介及趋势</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">FPGA产业及国内外厂家特点</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">FPGA硬件架构，基本结构，资源等及应用</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">FPGA设计流程</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">FGPA工具，实现流程</p>
							</li>
							<li class="sixth_model_list_con_end">
								<p class="dian"></p>
								<p class="sixth_text">FPGA选型原则</p>
							</li>
						</ul>
						<div class="sixth_text_num">
							<div>
								<img src="../../assets/image/fbga/icon_2.png" alt="" class="bulb_icon">
								<p>掌握技能</p>
							</div>
							<img src="../../assets/image/fbga/else_cion.png" alt="" class="triangle_cion">
						</div>
						<div class="sixth_text_txt">
							<p>*了解FPGA的构成，熟悉FPGA开发流程，掌握FPGA选型及策略</p>
						</div>
					</div>
					<div class="sixth_model_con">
						<div class="sixth_con_title">
							<p>Verilog HDL 基础</p>
							<span>（12课时）</span>
						</div>
						<ul class="sixth_model_list">
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">Verilog HDL简介</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">Verilog 语法规范及设计要点</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">FPGA基本仿真验证（功能验证，时序验证）</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">按键控制七段数码管实战（设计思路，代码编写及仿真，实战演示）</p>
							</li>
							<li class="sixth_model_list_con_end">
								<p class="dian"></p>
								<p class="sixth_text">localbus访问FPGA寄存器并控制内部计数器计数实战（设计思路，代码编写及仿真，实战演示）</p>
							</li>
						</ul>
						<div class="sixth_text_num">
							<div>
								<img src="../../assets/image/fbga/icon_2.png" alt="" class="bulb_icon">
								<p>掌握技能</p>
							</div>
							<img src="../../assets/image/fbga/else_cion.png" alt="" class="triangle_cion">
						</div>
						<div class="sixth_text_txt">
							<p>* 了解用Verilog HDL语言设计数字逻辑的优点</p>
							<p>* 掌握Verilog HDL语言的基本语法及规范</p>
							<p>* 学会组合逻辑及时序逻辑的设计以及组合+时序的状态机的设计方法</p>
							<p>* 学会仿真验证的基本测试程序的编写</p>
							<p>* 掌握静态时序分析的基本概念</p>
							<p>* 能使用Verilog语言开发常见功能的逻辑代码</p>
						</div>
					</div>
				</div>
				<div class="show_all" @click="allCourse">
					点击查看全部课程安排
					<img src="../../assets/image/fbga/all.png" alt="">
				</div>
			</div>
			<div class="sixth_model_alert" v-bind:class="{'show': show}" @click="closeAlert">
				<div class="sixth_alert_portion">
					<div class="sixth_model_con">
						<div class="sixth_con_title">
							<p>FPGA基础</p>
							<span>（10课时）</span>
						</div>
						<ul class="sixth_model_list">
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">FPGA简介及趋势</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">FPGA产业及国内外厂家特点</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">FPGA硬件架构，基本结构，资源等及应用</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">FPGA设计流程</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">FGPA工具，实现流程</p>
							</li>
							<li class="sixth_model_list_con_end">
								<p class="dian"></p>
								<p class="sixth_text">FPGA选型原则</p>
							</li>
						</ul>
						<div class="sixth_text_num">
							<div>
								<img src="../../assets/image/fbga/icon_2.png" alt="" class="bulb_icon">
								<p>掌握技能</p>
							</div>
							<img src="../../assets/image/fbga/else_cion.png" alt="" class="triangle_cion">
						</div>
						<div class="sixth_text_txt">
							<p>*了解FPGA的构成，熟悉FPGA开发流程，掌握FPGA选型及策略</p>
						</div>
					</div>
					<div class="sixth_model_con">
						<div class="sixth_con_title">
							<p>Verilog HDL 基础</p>
							<span>（12课时）</span>
						</div>
						<ul class="sixth_model_list">
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">Verilog HDL简介</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">Verilog 语法规范及设计要点</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">FPGA基本仿真验证（功能验证，时序验证）</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">按键控制七段数码管实战（设计思路，代码编写及仿真，实战演示）</p>
							</li>
							<li class="sixth_model_list_con_end">
								<p class="dian"></p>
								<p class="sixth_text">localbus访问FPGA寄存器并控制内部计数器计数实战（设计思路，代码编写及仿真，实战演示）</p>
							</li>
						</ul>
						<div class="sixth_text_num">
							<div>
								<img src="../../assets/image/fbga/icon_2.png" alt="" class="bulb_icon">
								<p>掌握技能</p>
							</div>
							<img src="../../assets/image/fbga/else_cion.png" alt="" class="triangle_cion">
						</div>
						<div class="sixth_text_txt">
							<p>* 了解用Verilog HDL语言设计数字逻辑的优点</p>
							<p>* 掌握Verilog HDL语言的基本语法及规范</p>
							<p>* 学会组合逻辑及时序逻辑的设计以及组合+时序的状态机的设计方法</p>
							<p>* 学会仿真验证的基本测试程序的编写</p>
							<p>* 掌握静态时序分析的基本概念</p>
							<p>* 能使用Verilog语言开发常见功能的逻辑代码</p>
						</div>
					</div>
					<div class="sixth_model_con">
						<div class="sixth_con_title">
							<p>FPGA开发工具环境</p>
							<span>（6课时）</span>
						</div>
						<ul class="sixth_model_list">
							<li class="sixth_model_list_con_end">
								<p class="dian"></p>
								<p class="sixth_text">FPGA设计，综合，仿真，调试等工具实战演练操作，掌握FPGA的仿真及调试方法</p>
							</li>
						</ul>
						<div class="sixth_text_num">
							<div>
								<img src="../../assets/image/fbga/icon_2.png" alt="" class="bulb_icon">
								<p>掌握技能</p>
							</div>
							<img src="../../assets/image/fbga/else_cion.png" alt="" class="triangle_cion">
						</div>
						<div class="sixth_text_txt">
							<p>* 使用Vivado软件，在XILINX开发板EK-U1-ZCU106-G-ED演练，完整进行FPGA设计所有流程，掌握FPGA开发板下载、调试的方法和技巧（创建文件，综合，编译，仿真，调试等）
							</p>
						</div>
					</div>
					<div class="sixth_model_con">
						<div class="sixth_con_title">
							<p>FPGA设计与技巧</p>
							<span>（10课时）</span>
						</div>
						<ul class="sixth_model_list">
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">速度与面积</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">硬件可实现原则</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">同步设计</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">时序分析（时序约束及收敛，时钟，复位等）</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">低功耗设计</p>
							</li>
							<li class="sixth_model_list_con_end">
								<p class="dian"></p>
								<p class="sixth_text">FPGA选型原则</p>
							</li>
						</ul>
						<div class="sixth_text_num">
							<div>
								<img src="../../assets/image/fbga/icon_2.png" alt="" class="bulb_icon">
								<p>掌握技能</p>
							</div>
							<img src="../../assets/image/fbga/else_cion.png" alt="" class="triangle_cion">
						</div>
						<div class="sixth_text_txt">
							<p>* 理解时序分析理论，能够解决在项目开发中所遇到的时序问题；且能够对跨时钟设计做出合理处理</p>
							<p>* 能够精通时序分析工具的使用，使其能够设计出满足时序要求的逻辑电路</p>
						</div>
					</div>
					<div class="sixth_model_con">
						<div class="sixth_con_title">
							<p>FPGA接口设计</p>
							<span>（12课时）</span>
						</div>
						<ul class="sixth_model_list">
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">SDRAM市场分析及发展</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">FPGA对DDR3/DDR4控制模型及逻辑控制</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">DDR3/DDR4 IP和分析（MIG IP）</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">DDR3/DDR4控制器（设计，仿真，实现），及JESD204B协议</p>
							</li>
							<li class="sixth_model_list_con_end">
								<p class="dian"></p>
								<p class="sixth_text">EK-U1-ZCU106-G-ED板的主要FPGA接口设计及外围接口设计（包括HDMI ，PCI-e，USB等）</p>
							</li>
						</ul>
						<div class="sixth_text_num">
							<div>
								<img src="../../assets/image/fbga/icon_2.png" alt="" class="bulb_icon">
								<p>掌握技能</p>
							</div>
							<img src="../../assets/image/fbga/else_cion.png" alt="" class="triangle_cion">
						</div>
						<div class="sixth_text_txt">
							<p>* 基于EK-U1-ZCU106-G-ED板的主要FPGA接口设计及外围接口设计，让学员掌握接口的设计方法：在专家演示下完成一种通信接口的设计</p>
						</div>
					</div>
					<div class="sixth_model_con">
						<div class="sixth_con_title">
							<p>专题讲解</p>
							<span>（6课时）</span>
						</div>
						<ul class="sixth_model_list">
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">图形视频编解码技术</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">FIR滤波器设计与实现（包括实操）</p>
							</li>
							<li class="sixth_model_list_con">
								<p class="dian"></p>
								<p class="sixth_text">HLS方法学在FPGA中实现TinyYOLO设计</p>
							</li>
							<li class="sixth_model_list_con_end">
								<p class="dian"></p>
								<p class="sixth_text">AI三次课程</p>
							</li>
						</ul>
						<div class="sixth_text_num">
							<div>
								<img src="../../assets/image/fbga/icon_2.png" alt="" class="bulb_icon">
								<p>掌握技能</p>
							</div>
							<img src="../../assets/image/fbga/else_cion.png" alt="" class="triangle_cion">
						</div>
						<div class="sixth_text_txt">
							<p>* 掌握图像和视频处理基础知识，并在专家讲解辅导下实现部分功能电路</p>
						</div>
					</div>
					<div class="sixth_model_con">
						<div class="sixth_con_title">
							<p>XILIINX开发板实战演练</p>
							<span>（8课时）</span>
						</div>
					</div>
					<div class="sixth_model_con">
						<ul class="sixth_model_list">
							<li>
								<img src="../../assets/image/fbga/mod_2.jpg" alt="">
							</li>
						</ul>
					</div>
					<div class="sixth_model_con">
						<ul class="sixth_model_list">
							<li>
								<img src="../../assets/image/fbga/mod_1.jpg" alt="">
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="seventh_model">
				<img src="../../assets/image/fbga/title_7.png" alt="" style="height:6rem">
				<img src="../../assets/image/fbga/user.png" alt="" class="user_images">
				<div class="swiper-container swiper2">
					<div class="swiper-wrapper">
						<div class="swiper-slide seventh_code">
							<div class="seventhCon">
								<div class="user_header">
									<img src="../../assets/image/fbga/head_1.png" alt="">
									<p>Alex</p>
								</div>
								<div class="user_text">
									我是一名普通的硬件工程师，之前有幸参加过EDA365组织的线下研讨会，
									大咖们的分享是真的很精彩，果然“大厂专家”不是浪得虚名呀，对于FPGA的内容，
									我的工作中有接触，但是也并非专业，很想去深入系统的学习一番，怎奈找到的资料课程都是零零散散的，
									最近听闻电巢（EDA365）要出FPGA的就业级课程，
									这算是我们这些小白工程师的福音呀，万分期待……
								</div>
							</div>
						</div>
						<div class="swiper-slide seventh_code">
							<div class="seventhCon">
								<div class="user_header">
									<img src="../../assets/image/fbga/head_2.png" alt="">
									<p>陈丛茂</p>
								</div>
								<div class="user_text">
									在电巢学习过荣老师的器件选型课程，讲解的非常细致深入，后来遇到疑问，
									在群里找荣老师，也得到了耐心的讲解，并给我提供了解决问题的另外一种思路。
									对于这门课程我充满期待，课程内容丰富，专家阵容强大，希望自己能迅速getFPGA的知识和技能。
									FPGA虽然有一定的学习难度，但学会了确实就成为了各家公司争抢的人才，
									期待学成后能得到高薪岗位的推荐~
								</div>
							</div>
						</div>
						<div class="swiper-slide seventh_code">
							<div class="seventhCon">
								<div class="user_header">
									<img src="../../assets/image/fbga/head_3.png" alt="">
									<p>船长</p>
								</div>
								<div class="user_text">
									我是转行来做FPGA的，最开始没头没脑的碰壁，后来朋友推荐了电巢直播，就一直再追着看荣老师的直播。
									荣老师直播中比较能照顾到观众，经常和我们互动。评论弹幕里的问题，
									能看到立刻就帮大家解答，跟荣老师一起学习真的是一件对我自身非常有益的事情。
									听说老师开了系统的FPGA进阶课程，我立刻就报名了，希望以后和老师一起，
									在FPGA的路上越走越远！
								</div>
							</div>
						</div>
						<div class="swiper-slide seventh_code">
							<div class="seventhCon">
								<div class="user_header">
									<img src="../../assets/image/fbga/head_4.png" alt="">
									<p>大宇吖</p>
								</div>
								<div class="user_text">
									对电巢印象最深的就是直播，每周直播必看，有时候是老师满满的干货分享，
									有时候是业界顶尖的企业做产品介绍，这些都是我储备行业知识的来源，
									就是因为总看直播，现在已经荣升电巢铁粉了！之前一直想学习FPGA的课程，
									但没合适的机会，这次跟着荣老师学习，一定会有很大的收获。
								</div>
							</div>
						</div>
						<div class="swiper-slide seventh_code">
							<div class="seventhCon">
								<div class="user_header">
									<img src="../../assets/image/fbga/head_5.png" alt="">
									<p>晨路</p>
								</div>
								<div class="user_text">
									我听过好几次荣庆安老师的直播课，从FPGA设计与验证、器件失效分析到器件国产化等，
									荣老师都讲的非常细致、深入浅出，让我收益匪浅，不仅解决了我工作上的难题，
									还拓宽了我的知识面与认知。非常感谢荣老师！
								</div>
							</div>
						</div>
					</div>
					<div class="swiper-pagination swiper_dian"></div>
				</div>
			</div>
			<div class="eighth_model">
				<img src="../../assets/image/fbga/title_8.png" alt="" style="height:6rem">
				<div class="inform_con">
					<div class="inform_list">
						<div class="issue">
							<img src="../../assets/image/fbga/issue.png" alt="">
							<p>学习形式是什么样的？</p>
						</div>
						<div class="answer">
							<img src="../../assets/image/fbga/answer.png" alt="">
							<p>线上通过巢粉引擎进行知识学习和实战项目的演示，每周一次直播辅导答疑。</p>
						</div>
					</div>
					<div class="inform_list">
						<div class="issue">
							<img src="../../assets/image/fbga/issue.png" alt="">
							<p>多长时间可以掌握这些知识和技能？学不会怎么办？</p>
						</div>
						<div class="answer">
							<img src="../../assets/image/fbga/answer.png" alt="">
							<p>我们根据学员基础差异化会设置学习计划，3个月一个培训周期，只要用心学，每个人都能成为企业不可或缺的高阶FPGA工程师。</p>
						</div>
					</div>
					<div class="inform_list">
						<div class="issue">
							<img src="../../assets/image/fbga/issue.png" alt="">
							<p>学完后可以推荐工作吗？</p>
						</div>
						<div class="answer">
							<img src="../../assets/image/fbga/answer.png" alt="">
							<p>我们与2000+企业达成了人才合作战略，会向完成培训的学员推荐相匹配的高薪岗位。截至目前，已成功输送数千名学员进入多家大厂的核心岗位。</p>
						</div>
					</div>
				</div>
				<div class="sixth_text_num">
					<div>
						<p>开营流程</p>
					</div>
					<img src="../../assets/image/fbga/else_cion.png" alt="" class="triangle_cion">
				</div>
				<div class="flowCon">
					<div class="flowTop">
						<div class="">
							<img src="../../assets/image/fbga/flow_1.png" alt="" class="icon_3">
							<p>报名</p>
							<p>支付成功</p>
						</div>
						<p>
							<img src="../../assets/image/fbga/next.png" alt="" class="next">
						</p>
						<div class="">
							<img src="../../assets/image/fbga/flow_2.png" alt="" class="icon_3">
							<p>添加</p>
							<p>助教老师</p>
						</div>
						<p>
							<img src="../../assets/image/fbga/next.png" alt="" class="next">
						</p>
						<div class="">
							<img src="../../assets/image/fbga/flow_3.png" alt="" class="icon_3">
							<p>获取实训营服</p>
							<p>务及入营链接</p>
						</div>
						<p>
							<img src="../../assets/image/fbga/next.png" alt="" class="next">
						</p>
						<div class="">
							<img src="../../assets/image/fbga/flow_4.png" alt="" class="icon_3">
							<p>开营学习</p>
							<p>开启实战</p>
						</div>
					</div>
				</div>
			</div>
			<div class="ninth_model">
				<img src="../../assets/image/fbga/title_9.png" alt="" style="height:6rem">
				<div class="ninth_model_con">
					<div class="about_con">
						<p>电巢是电子工程师的孵化巢，拥有200万+知识库，200+专家资源，共享实验室平台，
							2000+合作企业，旗下电子工程师社区（www.EDA365.com）是40余万电子工程师信赖的技术交流和能力提升的平台,
							电巢 服务于有创新有追求的工程师和积极寻求成长并坚信人才是核心竞争力的企业。
						</p>
					</div>
				</div>
			</div>
		</div>

		<div class="footer_mod">
			<div class="consult_btn">
				<div @click="arrangeShow">
					<img src="../../assets/image/fbga/consult.png" alt="">
					<p>报名咨询</p>
				</div>
			</div>
			<div class="down_btn">
				<div class="price">
					<p class="currentPrice">￥<span>{{ctivityCon.price}}</span></p>
					<p class="originalCost"><s>￥{{ctivityCon.origin_price}}</s> </p>
				</div>
				<div class="signUp_btn" @click="signUp">
					立即报名
				</div>
			</div>
		</div>

		<div class="consult_alert" v-bind:class="{'arrangeshow': arrangeshow}" @click="consultClose">
			<div class="consult_alert_con">
				<div class="consult_alert_ma">
					<p>保存识别二维码</p>
					<p>发送“FPGA”咨询入营</p>
					<img src="../../assets/image/fbga/erweima.png" alt="">
				</div>
				<div class="consult_close_btn">
					<img class="" src="../../assets/image/fbga/close.png" alt="">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import $ from 'jquery'
	import Swiper from '@/swiper/swiper.min.js'
	import '@/swiper/swiper.min.css'
	import axios from 'axios';
	import {
		pagebase,
		host,
		pagehost
	} from '@/utils/http.js';
	import wx from '@/utils/jweixin1.6.0.js';
	import utils from '@/utils/utils';

	// 百度
	var _hmt = _hmt || [];
	(function() {
		var hm = document.createElement("script");
		hm.src = "https://hm.baidu.com/hm.js?24b8cea1e8cafdb512e2f597cf3fa8df";
		var s = document.getElementsByTagName("script")[0];
		s.parentNode.insertBefore(hm, s);
	})();

	export default {
		data() {
			return {
				aid: this.$route.query.aid || '',
				ctivityCon: {},
				tabNum: 0,
				fpgaShow: false,

				show: false,
				xHeader: false,

				oneShow: true,
				twoShow: false,
				threeShow: false,
				fourShow: false,

				showAll: true,
				showAwait: false,
				showAccomplish: false,
				showCancel: false,
				teacher5: false,

				arrangeshow: false,
			};
		},
		created() {
			let image = new Image();
			image.src = require('../../assets/image/fbga/banner_1.jpg');
			image.onload = () => {
				$('.banner').append(image);
				$('.banner > img').css('width', '100%');
				this.fpgaShow = true;
			}
		},
		mounted() {
			this.init();
		},
		methods: {
			init(){
				this.getSwiperOne();
				this.getSwiperTeacher();
				this.getactivityCon();
			},
			fourthClick(v, type) {
				if (type === 'first') {
					this.oneShow = true;
					this.twoShow = false;
					this.threeShow = false;
					this.fourShow = false;
					$('.fourth_model_circle_img').css('transform', 'rotate(0deg)');
				} else if (type === 'second') {
					this.oneShow = false;
					this.twoShow = true;
					this.threeShow = false;
					this.fourShow = false;
					$('.fourth_model_circle_img').css('transform', 'rotate(90deg)');
				} else if (type === 'third') {
					this.oneShow = false;
					this.twoShow = false;
					this.threeShow = true;
					this.fourShow = false;
					$('.fourth_model_circle_img').css('transform', 'rotate(270deg)');
				} else if (type === 'fourth') {
					this.oneShow = false;
					this.twoShow = false;
					this.threeShow = false;
					this.fourShow = true;
					$('.fourth_model_circle_img').css('transform', 'rotate(180deg)');
				}
				var divs = document.getElementsByClassName("fourth_css");
				for (var y = 0; y < divs.length; y++) {
					var divv = divs[y];
					if (divv == document.getElementById("fourth" + v + "_content")) {
						divv.style.display = "block";
					} else {
						divv.style.display = "none";
					}
				}
			},
			Myclick(v, type) {
				if (type === 'all') {
					this.showAll = true;
					this.showAwait = false;
					this.showAccomplish = false;
					this.showCancel = false;
					this.teacher5 = false;
				} else if (type === 'await') {
					this.showAll = false;
					this.showAwait = true;
					this.showAccomplish = false;
					this.showCancel = false;
					this.teacher5 = false;
				} else if (type === 'accomplish') {
					this.showAll = false;
					this.showAwait = false;
					this.showAccomplish = true;
					this.showCancel = false;
					this.teacher5 = false;
				} else if (type === 'cancel') {
					this.showAll = false;
					this.showAwait = false;
					this.showAccomplish = false;
					this.showCancel = true;
					this.teacher5 = false;
				} else if (type === 'teacher5') {
					this.showAll = false;
					this.showAwait = false;
					this.showAccomplish = false;
					this.showCancel = false;
					this.teacher5 = true;
				}
				var divs = document.getElementsByClassName("Tab_css");
				for (var y = 0; y < divs.length; y++) {
					var divv = divs[y];
					if (divv == document.getElementById("Tab" + v + "_content")) {
						divv.style.display = "block";
					} else {
						divv.style.display = "none";
					}
				}
				var teacher = document.getElementsByClassName("teacherName");
				for (var i = 0; i < teacher.length; i++) {
					var teav = divs[i];
					if (teav == document.getElementById("name_" + v)) {
						teav.style.color = "red";
					} else {
						teav.style.color = "#080943";
					}
				}
			},
			// No.1
			getSwiperOne() {
				new Swiper('.swiper1', {
					observer:true,
					observeParents:true,
					watchSlidesProgress: true, //查看slide的progress
					resistanceRatio: 0, //禁止边缘移动
					pagination: {
						el: '.swiper_dian',
					},
				});
			},
			// 名师
			getSwiperTeacher() {
				new Swiper('.swiper2', {
					observer:true,
					observeParents:true,
					pagination: {
						el: '.swiper_dian',
					},
				})
				new Swiper('.swiper2', {
					watchSlidesProgress: true, //查看slide的progress
					resistanceRatio: 0, //禁止边缘移动
				});
			},

			getactivityCon() {
				this.$http({
					url: '/activity/Info',
					method: 'get',
					params: {
						activity_id: this.aid,
					},
				}).then(res => {
					if (res.code >= 0) {
						let data = res.data;
						this.ctivityCon = data;
						document.title = data.title;
						this.configShare();
					}
				})
			},

			// 报名按钮
			signUp() {
				var succeedUrl = encodeURIComponent(pagebase + '/#/paySucceed?activity_id=' + this.aid);
				if (utils.browserChecker.isWx()) {
					var channel = this.$route.query.channel || '';
					var open = encodeURIComponent(pagebase + '/#/payment?activity_id=' + this.aid + '&project=emc' + '&channel=' + channel + '&succeed_url=' + succeedUrl);
					var url = 'http://edu.eda365.com/wechat_redirect.php?jump_url=' + open;
					window.location.href = url;
				} else {
					this.$router.push({
						path: '/payment',
						query: {
							activity_id: this.aid,
							channel: this.$route.query.channel || '',
							project: 'fpga',
							track_id: this.$route.query.track_id || '',
							succeed_url: succeedUrl,
						}
					})
				}
			},
			allCourse() {
				this.show = true;
			},
			closeAlert() {
				this.show = false;
			},
			arrangeShow() {
				this.arrangeshow = true;
			},
			consultClose() {
				this.arrangeshow = false;
			},
			configShare() {
				axios({
					url: host + '/user/getShareSign',
					method: 'get',
					params: {
						url: encodeURIComponent(window.location.origin + window.location.pathname + window.location.search)
					}
				}).then((res) => {
					if (res.data.code >= 0) {
						wx.config({
							debug: false,
							appId: 'wx9887a87ead532547',
							timestamp: res.data.data.timestamp,
							nonceStr: res.data.data.noncestr,
							signature: res.data.data.signature,
							jsApiList: [
								'checkJsApi',
								'updateTimelineShareData',
								'updateAppMessageShareData',
								'onMenuShareAppMessage',
								'onMenuShareTimeline'
							]
						})
						wx.checkJsApi({
							jsApiList: [
								'updateTimelineShareData',
								'updateAppMessageShareData',
								'onMenuShareAppMessage',
								'onMenuShareTimeline'
							],
							success: function() {},
							error: function() {}
						});
						wx.ready(function() {
							var shareData = {
								title: this.ctivityCon.title,
								desc: this.ctivityCon.summary,
								link: window.location.href,
								imgUrl: pagehost + '/images/common/logo.jpeg',
								success: function() {},
								error: function() {}
							};
							wx.updateAppMessageShareData(shareData);
							wx.updateTimelineShareData(shareData);
						})
						wx.error(function() {});
					}
				})
			},
		},
	}
</script>

<style lang="css" scoped>
	.fbga {
		box-sizing: border-box;
		width: 100%;
		background-color: #1F3364;
	}

	.banner {
		width: 100%;
		background-color: #1F3364;
	}

	.content {
		width: 100%;
		box-sizing: border-box;
		background-color: #1F3364;
		padding: 3.8rem 1.4rem 8.5rem 1.4rem;
	}

	/* 模块零 */
	.zeroModule {
		background-color: #FFF;
		box-sizing: border-box;
		padding: 0 1.6rem 2rem 1.6rem;
		border-radius: 1.5rem;
	}

	.zeroModuleDescribe {
		color: #3233C0;
		font-size: 1.4rem;
		font-weight: bolder;
		padding-bottom: .8rem;
	}

	.listChild {
		display: flex;
		align-items: center;
	}

	.childNum {
		width: 10.2%;
		height: 3.2rem;
		border: .1rem dashed #5F60F6;
		border-radius: 1.8rem;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.childNum p {
		text-align: center;
		font-size: 1.6rem;
		color: #FFFFFF;
		width: 2.4rem;
		height: 2.4rem;
		line-height: 2.4rem;
		border-radius: 1.8rem;
		background-color: #5F60F6;
	}

	.fillChild {
		padding-left: 1.5rem;
		margin-top: .5rem;
		margin-bottom: .5rem;
	}

	.fillChild p {
		height: 1.5rem;
		border-left: .1rem solid #5F60F6;
	}

	.childText {
		width: 86%;
		margin-left: 1.3rem;
		font-size: 1.4rem;
		color: #485E80;
	}

	.employment {
		background-color: #5F60F6;
		margin: 2.3rem 1rem;
		padding: .4rem 0;
		text-align: center;
		font-size: 1.6rem;
		color: #FFFFFF;
	}
	
	.swiperOneCon{
		height: 22rem;
		box-sizing: border-box;
		padding: 1rem;
	}

	.jobRequirements {
		width: 100%;
		box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
		object-fit: cover;
		border-radius: .5rem;
	}

	/* 模块一 */
	.first_model {
		margin-top: 2rem;
		background-color: #FFF;
		box-sizing: border-box;
		padding: 0 1.6rem;
		padding-bottom: 1.5rem;
		border-radius: 1.5rem;
	}

	.tab_bar {
		width: 100%;
	}

	.tabBtn {
		top: 8.8rem;
	}

	.tab_con {
		box-sizing: border-box;
		width: 100%;
		height: 4.4rem;
		display: flex;
		padding: .6rem 0;
		text-align: center;
		background-color: #5F60F6;
		border-radius: 1rem 1rem 0 0;
	}

	.first_tab {
		width: 24.25%;
		font-size: 1.2rem;
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		position: relative;
	}

	.decorationLine {
		font-size: 2.4rem;
		color: #fff;
		position: relative;
	}

	.decorationLine:after {
		content: '';
		position: absolute;
		left: 50%;
		right: 0;
		text-align: center;
		width: 6.5rem;
		height: 3.3rem;
		margin-top: .1rem;
		margin-left: -3.2rem;
		background-color: #EEF3FF;
		border-radius: .6rem;
		z-index: 1;
	}

	.tab_icon {
		display: none;
	}

	.down_icon {
		width: 1.35rem;
		height: .65rem;
		position: absolute;
		bottom: 0;
		left: 50%;
		margin-left: -.65rem;
		margin-bottom: -1.1rem;
		z-index: 2;
	}

	.image1 {
		position: relative;
		display: block;
		width: 3rem;
		z-index: 2;
	}

	.image2 {
		position: relative;
		display: block;
		width: 3rem;
		z-index: 2;
	}

	.wire {
		width: 1%;
	}

	.wire img {
		width: 100%;
		height: 100%;
	}

	.first_tab:nth-child(1) {
		border-left: none;
	}

	.tab_css {
		height: 30rem;
		position: relative;
		background-color: #EEF3FF;
	}

	.first_model_con {
		height: 100%;
		box-sizing: border-box;
		padding: 0 .8rem;
		border-radius: 0 0 1rem 1rem;
	}

	.first_img {
		padding-top: 1.5rem;
		width: 30rem;
		height: 14rem;
	}

	.first_img img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.first_text {
		margin-top: 1.85rem;
		margin-left: 1rem;
	}

	.first_text_title {
		font-size: 1.6rem;
		color: #3233C0;
		font-weight: bolder;
	}

	.first_text_con {
		margin-top: 1rem;
		font-size: 1.4rem;
		color: #485E80;
	}

	/* 模块二 */
	.second_model {
		margin-top: 2rem;
		background-color: #FFF;
		box-sizing: border-box;
		padding: 0 1.6rem 2rem 1.6rem;
		border-radius: 1.5rem;
	}

	.second_model_list {}

	.second_model_con {
		display: flex;
		align-items: center;
	}

	.second_model_con img {
		width: 6rem;
	}

	.second_text {
		margin-left: 1.5rem;
		width: 100%;
		padding: 1.5rem 0;
		border-bottom: .1rem dashed #485E80;
	}

	.second_text_child {
		margin-left: 2rem;
		width: 100%;
		padding: 1.5rem 0;
	}

	.second_text_title {
		font-size: 1.6rem;
		color: #3233C0;
		font-weight: 600;
	}

	.second_text_con {
		font-size: 1.4rem;
		color: #485E80;
		margin-top: .8rem;
	}

	/* 模块三 */
	.third_model {
		margin-top: 2rem;
		background-color: #FFF;
		box-sizing: border-box;
		padding: 0 1.6rem 2rem 1.6rem;
		border-radius: 1.5rem;
	}

	.third_model_list {}

	.third_model_con {
		display: flex;
		margin-top: 1.85rem;
	}

	.third_text_num {
		display: flex;
		flex-direction: column;
		margin-left: -2.4rem;
		margin-right: 1.2rem;
	}

	.third_text_num p {
		width: 5rem;
		height: 3rem;
		line-height: 3rem;
		text-align: center;
		font-size: 1.8rem;
		background-color: #F9D346;
		color: #0218A7;
	}

	.third_text_num img {
		width: .85rem;
		height: .85rem;
	}

	.third_text_con {
		color: #3233C0;
		font-size: 1.4rem;
		font-weight: bolder;
	}

	/* 模块四 */
	.fourth_model {
		margin-top: 2rem;
		background-color: #FFF;
		box-sizing: border-box;
		padding: 0 1.6rem 2rem 1.6rem;
		border-radius: 1.5rem;
	}

	.fourth_model_con {
		width: 100%;
		background: url('../../assets/image/fbga/back.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		height: 22rem;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		position: relative;
	}

	.fourth_model_list_1 {
		margin-top: 2rem;
		width: 12.5rem;
		height: 6rem;
		background: linear-gradient(to left, #5F60F6, #9899FB);
		border-radius: .5rem;
		font-size: 1.4rem;
		display: flex;
		justify-content: center;
		flex-direction: column;
		text-align: center;
		color: #FFF;
	}

	.fourth_model_list {
		margin-top: 2rem;
		width: 12.5rem;
		height: 6rem;
		background-color: #D1D2FF;
		border-radius: .5rem;
		font-size: 1.4rem;
		display: flex;
		justify-content: center;
		flex-direction: column;
		text-align: center;
		color: #485E80;
	}

	.fourthTab {
		font-size: 1.4rem;
		color: #fff;
		background: linear-gradient(to left, #5F60F6, #9899FB);
		position: relative;
	}

	.fourth_model_circle_img {
		position: absolute;
		width: 7rem;
		top: 50%;
		left: 50%;
		margin-top: -4rem;
		margin-left: -3.5rem;
	}

	.fourth_model_list_img {
		position: absolute;
		width: 4rem;
		top: 50%;
		left: 50%;
		margin-top: -2.5rem;
		margin-left: -2rem;
	}

	.fourth_model_text {
		margin-top: .5rem;
		background-color: #5F60F6;
		box-sizing: border-box;
		padding: 1.2rem;
		font-size: 1.4rem;
		color: #FFF;
		border-radius: 1rem;
	}

	.fourth_css {
		height: 7.5rem;
		display: none;
		position: relative;
	}

	/* 模块五 */
	.fifth_model {
		margin-top: 2rem;
		background-color: #FFF;
		box-sizing: border-box;
		padding: 0 1.6rem 2rem 1.6rem;
		border-radius: 1.5rem;
	}

	.Tab_bar {
		width: 100%;
	}

	.TabBtn {
		top: 8.8rem;
	}

	.Tab_bar ul {
		display: flex;
		padding: 0px;
		margin: 0px;
		text-align: center;
	}

	.Tab_bar li {
		width: 25%;
		font-size: 1.2rem;
	}

	.Tab_bar li:hover {
		color: red;
	}

	.DecorationLine {
		color: red;
		position: relative;
		font-weight: 600;
	}

	.teacher_icon {
		margin-top: 1.5rem;
		width: 4.5rem;
		height: 4.5rem;
		border-radius: 50%;
		opacity: 0.5;
	}

	.opacity {
		opacity: 1;
	}

	.teacherName {
		color: rgba(8, 9, 67, 0.6);
	}

	.color {
		color: rgba(8, 9, 67, 1);
	}

	.Tab_css {
		display: none;
		position: relative;
	}

	.teacher_con {
		background-color: #EEF3FF;
		box-sizing: border-box;
		padding: 1.5rem 1rem 1.5rem 1rem;
		display: flex;
		align-items: center;
		border-radius: .5rem;
		height: 23rem;
	}

	.teacher_head {
		width: 10.4rem;
		object-fit: cover;
		height: 15.5rem;
	}

	.teacher_txt {
		box-sizing: border-box;
		padding: 0 0 0 1rem;
		line-height: 1.7rem;
	}

	.teacher_name {
		font-size: 1.5rem;
		color: #3233C0;
		font-weight: bolder;
	}

	.down_1 {
		width: 2rem;
		position: absolute;
		left: 3rem;
	}

	.down_2 {
		width: 2rem;
		position: absolute;
		left: 10.8rem;
	}

	.down_3 {
		width: 2rem;
		position: absolute;
		left: 18.5rem;
	}

	.down_4 {
		width: 2rem;
		position: absolute;
		left: 26.5rem;
	}

	.teacher_synopsis {
		margin-top: .8rem;
		color: #0A2480;
		font-size: 1.1rem;
	}

	/* 模块六 */
	.sixth_model {
		position: relative;
		margin-top: 2rem;
		background-color: #FFF;
		box-sizing: border-box;
		padding: 0 1.6rem 4rem 1.6rem;
		border-radius: 1.5rem;
	}

	.headline {
		/* margin-left: 1.5rem;
  margin-top: .4rem; */
	}

	.sixth_con_1 {
		margin-left: 1.6rem;
	}

	.sixth_con_text {
		font-size: 1.4rem;
		font-weight: bolder;
		color: #3233C0;
	}

	.sixth_portion {
		position: relative;
		height: 55rem;
		overflow: hidden;
	}

	.sixth_model_con {
		box-sizing: border-box;
		width: 100%;
		background-color: #EEF3FF;
		margin-top: 1.5rem;
		border-radius: .5rem;
		margin-bottom: 1.5rem;
	}

	.sixth_con_title {
		width: 100%;
		height: 3rem;
		background-color: #5F60F6;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFF;
		border-radius: .5rem .5rem 0 0;
	}

	.sixth_con_title p {
		font-size: 1.4rem;
	}

	.sixth_con_title span {
		font-size: 1.2rem;
	}

	.sixth_model_list {
		box-sizing: border-box;
		padding: 0 .5rem 1rem .5rem;
	}

	.sixth_model_list img {
		width: 100%;
	}

	.sixth_model_list_con {
		box-sizing: border-box;
		width: 100%;
		padding: 1rem 0;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		border-bottom: .1rem dashed #485E80;
	}

	.sixth_model_list_con_end {
		box-sizing: border-box;
		width: 100%;
		padding: 1rem 0;
		box-sizing: border-box;
		display: flex;
		align-items: center;
	}

	.dian {
		width: .7rem;
		height: .7rem;
		border-radius: 50%;
		background-color: #3233C0;
		margin: 0 1rem;
	}

	.sixth_text {
		width: 28rem;
		font-size: 1.4rem;
		color: #3233C0;
		font-weight: bolder;
	}

	.sixth_text_num {
		margin-top: 1.5rem;
		display: flex;
		flex-direction: column;
		margin-left: -.9rem;
		margin-right: 1.2rem;
	}

	.sixth_text_num div {
		width: 13rem;
		height: 3rem;
		line-height: 3rem;
		text-align: center;
		font-size: 1.4rem;
		font-weight: bolder;
		background-color: #F9D346;
		color: #0218A7;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.bulb_icon {
		width: 1.7rem;
		height: 1.7rem;
		margin-right: .2rem;
	}

	.triangle_cion {
		width: .85rem;
		height: .85rem;
	}

	.sixth_text_txt {
		box-sizing: border-box;
		font-size: 1.2rem;
		color: #485E80;
		padding: 0 1.5rem;
	}

	.sixth_text_txt p {
		margin-top: .2rem;
	}

	.show_all {
		box-sizing: border-box;
		width: 90.1%;
		padding: 1.4rem 0;
		background: linear-gradient(rgb(223 223 223 / 70%), rgb(197 197 197));
		color: #DD3700;
		font-size: 1.4rem;
		font-weight: 600;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		margin-top: -3rem;
	}

	.show_all img {
		height: 1.8rem;
		margin-top: .3rem;
	}

	.sixth_model_alert {
		display: none;
		box-sizing: border-box;
		z-index: 10;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.8);
		overflow: auto;
		padding: 2rem 1.6rem 2rem 1.6rem;
	}

	.sixth_alert_portion {
		box-sizing: border-box;
		padding: 0rem 1.5rem 2rem 1.5rem;
		background-color: #FFF;
	}

	.show {
		height: 100%;
		display: block;
	}

	/* 模块七 */
	.seventh_model {
		box-sizing: border-box;
		margin-top: 2rem;
		background-color: #FFF;
		padding: 0 1.6rem 2rem 1.6rem;
		border-radius: 1.5rem;
	}

	.user_images {
		width: 100%;
	}

	.seventh_code {
		box-sizing: border-box;
		padding: 1rem;
		margin-top: 1rem;
		height: 26.5rem;
	}
	
	.seventhCon{
		height: 22.5rem;
		border-radius: .5rem;
		background-color: #FFFFFF;
		box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
	}

	.swiper-pagination {
		margin-top: 1rem;
	}

	.user_header {
		display: flex;
		align-items: center;
		padding: 1rem ;
	}

	.user_header img {
		width: 4.5rem;
		height: 4.5rem;
		border-radius: 50%;
		object-fit: cover;
	}

	.user_header p {
		margin-left: 1rem;
	}

	.user_text {
		box-sizing: border-box;
		font-size: 1.2rem;
		color: #485E80;
		padding: 0 1rem 1rem 1rem;
	}

	/* 模块八 */
	.eighth_model {
		box-sizing: border-box;
		margin-top: 2rem;
		background-color: #FFF;
		padding: 0 1.6rem 2rem 1.6rem;
		border-radius: 1.5rem;
	}

	.inform_con {
		margin-top: 2.7rem;
		background-color: #EEF3FF;
		border-radius: .5rem;
		box-sizing: border-box;
		padding: 0 .9rem .4rem .9rem;
	}

	.inform_con img {
		height: 2.5rem;
		margin-right: 1.4rem;
	}

	.inform_list {
		border-bottom: .1rem dashed #485E80;
		padding-bottom: 1.2rem;
		padding-top: 1.2rem;
	}

	.inform_list:nth-last-child(1) {
		border-bottom: none;
	}

	.issue {
		display: flex;
		align-items: center;
		color: #3233C0;
		font-size: 1.4rem;
		font-weight: 600;
	}

	.answer {
		line-height: 1.7rem;
		margin-top: .6rem;
		display: flex;
		align-items: center;
		color: #485E80;
		font-size: 1.2rem;
	}

	.flowCon {
		box-sizing: border-box;
	}

	.flowTop {
		display: flex;
		justify-content: space-between;
	}

	.flowTop div {
		font-size: 1.2rem;
		color: #0A2480;
		font-weight: 600;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.icon_3 {
		width: 6.5rem;
	}

	.next {
		width: 1.2rem;
		margin-top: 3rem;
	}

	/* 模块九 */
	.ninth_model {
		box-sizing: border-box;
		margin-top: 2rem;
		background-color: #FFF;
		padding: 0 1.6rem 2rem 1.6rem;
		border-radius: 1.5rem;
	}

	.about_con {
		margin-top: 1.5rem;
		line-height: 2.2rem;
		font-size: 1.4rem;
		color: #0A2480;
	}

	.footer_mod {
		position: fixed;
		align-items: center;
		left: 0;
		bottom: 0;
		box-sizing: border-box;
		width: 100%;
		z-index: 5;
	}

	.down_btn {
		box-sizing: border-box;
		width: 100%;
		background-color: #5F60F6;
		z-index: 3;
		justify-content: center;
		display: flex;
		justify-content: space-between;
		padding: .8rem 1.4rem;
		color: #FFF;
	}

	.price {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.originalCost {
		margin-top: 1rem;
		margin-left: 1rem;
		color: #DDD;
		font-size: 1.2rem;
	}

	.currentPrice {
		font-size: 1.4rem;
	}

	.currentPrice span {
		font-size: 2.8rem;
		font-weight: normal;
		color: #F9F9F9;
	}

	.signUp_btn {
		box-sizing: border-box;
		text-align: center;
		width: 18.1rem;
		height: 4.4rem;
		line-height: 4.4rem;
		font-size: 1.8rem;
		font-weight: 600;
		color: #1F3364;
		background-color: #F9D346;
		border-radius: 2.2rem;
	}

	.consult_btn {
		display: flex;
		justify-content: flex-end;
		z-index: 5;
		height: 10rem;
	}

	.consult_btn img {
		width: 7.5rem;
	}

	.consult_btn p {
		width: 7rem;
		text-align: center;
		margin-top: -1.8rem;
		padding: .4rem 0;
		color: #FFE864;
		font-size: 1rem;
		background-color: rgba(0, 0, 0, 0.6);
		position: absolute;
		z-index: 5;
		border-radius: .5rem;
	}

	/* .consult_btn img{
width: 7.5rem;
margin-right: 1.3rem;
margin-bottom: .5rem;
} */



	.consult_alert {
		display: none;
		z-index: 5;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.8);
	}

	.consult_alert_con {
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -14rem;
		margin-left: -14rem;
		width: 28rem;
		height: 28rem;
		background-color: #F3F7FC;
		border-radius: 1rem;
	}

	.consult_alert_ma {
		height: 100%;
		display: flex;
		font-size: 1.8rem;
		font-weight: 600;
		color: #080943;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.consult_alert_ma img {
		width: 15rem;
		height: 15rem;
	}

	.arrangeshow {
		display: block;
	}

	.consult_close_btn {
		margin-top: .5rem;
		display: flex;
		justify-content: center;
	}

	.consult_close_btn img {
		width: 3.8rem;
		height: 3.8rem;
	}



	@media (min-width: 751px) {
		.sixth_model_alert {
			width: 750px;
			left: 50%;
			margin-left: -375px;
		}

		.sixth_alert_portion {
			box-sizing: border-box;
			position: absolute;
			width: 32rem;
			height: 880px;
			top: 50%;
			left: 50%;
			margin-left: -16rem;
			margin-top: -440px;
			overflow: auto;
		}

		.footer_mod {
			width: 750px;
			left: 50%;
			margin-left: -375px;
		}
	}

	@media (max-width: 1600px) {
		.sixth_alert_portion {
			box-sizing: border-box;
			position: absolute;
			width: 32rem;
			height: 580px;
			top: 50%;
			left: 50%;
			margin-left: -16rem;
			margin-top: -290px;
			overflow: auto;
		}
	}
</style>
